import { z } from "zod"
import { buildPaginationSchema } from "../../shared/pagination_dtos"

export const EmailReaderMessagesQuerySchema = buildPaginationSchema({
  minTotal: 1,
  maxTotal: 50,
}).extend({
  integrationId: z.string().transform(BigInt),
  pageToken: z.string().optional(),
  searchMode: z.enum(["threadId", "senderEmail"]).optional(),
  search: z.string().trim().optional(),
})

export const EmailReaderThreadParamsSchema = z.object({
  threadId: z.string(),
})

export const EmailReaderThreadQuerySchema = z.object({
  integrationId: z.string().transform(BigInt),
})
